export const SORT_VALUES = {
  asc: 'asc',
  completed: 'completed',
  desc: 'desc',
  uncompleted: 'uncompleted'
};